module.exports = __webpack_public_path__ + "img/15.ce250f0d.jpg";